import flame from "../../assets/images/flame.png";
import handleNumber from "../../services/Helpers/HandleNumber";

export default function ResultsBall(props) {
  
  return (
    <div className={"results-ball " + handleNumber(props.label)}>
      {props.label}
      {props.winBall ? (
        <div className="flame-ball">
          <img src={flame} alt="flame-ball" />
        </div>
      ) : null}
    </div>
  );
}
